export const nestedForm = () => ({
  addFields() {
    const template = this.$refs.nestedFieldsTemplate;
    const id = Date.now();
    const fields = template.innerHTML.replaceAll("NESTED_CHILD_INDEX", id);
    template.insertAdjacentHTML("beforebegin", fields);
  },
});

export const nestedFields = ({ newRecord }) => ({
  removeFields() {
    if (newRecord) {
      this.$root.remove();
    } else {
      this.$root.hidden = true;
    }
  },
});
